import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/procedimento`

    return {
        index(params) {
            return repository.get(`${baseUrl}`, params)
        },
        getAtendimentos(params) {
            return repository.get(`${baseUrl}/atendimento?${urlUtil.serialize(params)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        show() {
            return repository.get(`${baseUrl}`)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        datatable(queryParams) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParams)}`)
        },
        getUnidades(queryParms) {

            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(queryParms)}`)
        },
        getInfraestruturas(queryParms) {

            return repository.get(`${baseUrl}/infraestrutura?${urlUtil.serialize(queryParms)}`)
        },
        getAtendimentoResponsavel(queryParms) {

            return repository.get(`${baseUrl}/atendimento-responsavel?${urlUtil.serialize(queryParms)}`)
        },
        getAtendimentoPaciente(queryParms) {

            return repository.get(`${baseUrl}/atendimento-paciente?${urlUtil.serialize(queryParms)}`)
        },
        getProcedimentos(queryParms) {

            return repository.get(`${baseUrl}/procedimento?${urlUtil.serialize(queryParms)}`)
        },
        getProcedimentosUsuario(queryParms) {

            return repository.get(`${baseUrl}/procedimento-usuario?${urlUtil.serialize(queryParms)}`)
        },
        getCadastroIndividual(queryParms) {

            return repository.get(`${baseUrl}/cadastro-individual?${urlUtil.serialize(queryParms)}`)
        },
        loadUnidades(queryParms) {

            return repository.get(`${baseUrl}/load-unidade?${urlUtil.serialize(queryParms)}`)
        },
        loadLocaisAtendimento(queryParms) {

            return repository.get(`${baseUrl}/load-local-atendimento?${urlUtil.serialize(queryParms)}`)
        },
        loadProfissionais(queryParms) {

            return repository.get(`${baseUrl}/load-profissional?${urlUtil.serialize(queryParms)}`)
        },
        getEquipes(queryParms) {

            return repository.get(`${baseUrl}/equipe?${urlUtil.serialize(queryParms)}`)
        },
        getOcupacoes(queryParms) {

            return repository.get(`${baseUrl}/ocupacao?${urlUtil.serialize(queryParms)}`)
        },
        getOcupacoesAuxiliar(queryParms) {

            return repository.get(`${baseUrl}/ocupacao-auxiliar?${urlUtil.serialize(queryParms)}`)
        },
        getCadastroDomiciliar(queryParms) {

            return repository.get(`${baseUrl}/cadastro-domiciliar?${urlUtil.serialize(queryParms)}`)
        },
        getProcedimentosAgendados(queryParms) {

            return repository.get(`${baseUrl}/procedimento-agendado?${urlUtil.serialize(queryParms)}`)
        },
        comunidade: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-comunidade?${urlUtil.serialize(queryParms)}`)
            },
        },
    }
}